import { PropTypes } from 'prop-types';
import React from 'react';

const ClaimWizardReviewSection = ({ editLabel, onEdit, section }) => (
  <div className="claim-wizard-review-section">
    <div className="claim-wizard-review-header">
      <h2>{section.label}</h2>
      <button type="button" className="button small" onClick={() => onEdit(section.step)}>
        {editLabel}
      </button>
    </div>
    {section.rows.map(([label, value]) => (
      <div className="claim-wizard-review-row" key={label}>
        <span>{label}</span>
        <strong>{value}</strong>
      </div>
    ))}
  </div>
);

ClaimWizardReviewSection.propTypes = {
  editLabel: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  section: PropTypes.shape({
    label: PropTypes.string.isRequired,
    rows: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.node)).isRequired,
    step: PropTypes.number.isRequired,
  }).isRequired,
};

export default ClaimWizardReviewSection;
